export default function ServiceLabel({ text, boldText }) {
  return (
    <span className="serviceLabel">
      <span className="serviceLabelText">{text}</span>
      <b className="serviceLabelPrice">{boldText}</b>
    </span>
  );
}